import interceptor, { baseUrl } from '../common/interceptor';
import { APIPaths } from '../common/constants';
import { ApiResponse } from './types';
import { GetProductsWithPaginationAndSearchResponse } from '@/pages/Inventory/type';
import {
  getUserTimeZone,
  OperationType,
} from '@/common/interceptor/interceptor';
import axios, { AxiosResponse } from 'axios';

export const AddInventory = (
  token: string,
  model: unknown
): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost('Post', APIPaths.inventory + 'write/', model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log('error while adding new inventory', error?.response);
        reject(error?.response);
      });
  });
};

export const GetSingleInventoryDetailById = (
  id: string,
  token: string
): Promise<ApiResponse> => {
  const url = `${APIPaths.inventory}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost('Post', url, null, token, null, OperationType.Read)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log('error while getting single inventory', error?.response);
        reject(error?.response);
      });
  });
};

export interface InventoryLocationsPaginationResponse {
  locations: unknown[];
  pagination: {
    page: number;
    page_size: number;
    total_count: number;
    total_pages: number;
  };
}

export const GetInventoryLocationWithPagination = (
  id?: string,
  model?: { page?: number; page_size?: number },
  token?: string
): Promise<ApiResponse<InventoryLocationsPaginationResponse>> => {
  const url = `${APIPaths.inventory}${id}/locations/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost('Post', url, model, token, null, OperationType.Read)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log('error while getting inventory locations', error?.response);
        reject(error?.response);
      });
  });
};

export const GetInventorySerialHistory = (
  id: string,
  token: string,
  page = 1,
  pageSize = 20
): Promise<ApiResponse> => {
  const url = `${APIPaths.inventory}${id}/`;

  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        url,
        {
          action: 'load_serial_history',
          page,
          page_size: pageSize,
        },
        token,
        null,
        OperationType.Read
      )
      .then((res) => resolve(res))
      .catch((error) => {
        console.log(
          'error while getting inventory serial history',
          error?.response
        );
        reject(error?.response);
      });
  });
};

export const DownloadInventoryRecord = async (
  id: string,
  token: string
): Promise<AxiosResponse<Blob>> => {
  return axios({
    method: 'POST',
    url: `${baseUrl}${APIPaths.inventory}${id}/`,
    data: {
      action: 'download',
      file_type: 'xlsx',
    },
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      timezone: getUserTimeZone(),
    },
    responseType: 'blob',
  });
};

export const DownloadInventoryList = async (
  token: string,
  payload: Record<string, unknown>
): Promise<AxiosResponse<Blob>> => {
  return axios({
    method: 'POST',
    url: `${baseUrl}${APIPaths.inventory}`,
    data: payload,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      timezone: getUserTimeZone(),
    },
    responseType: 'blob',
  });
};

export const TriggerInventoryRefresh = (
  token: string
): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.inventory_refresh,
        null,
        token,
        null,
        OperationType.Read
      )
      .then((res) => resolve(res))
      .catch((error) => {
        console.log(
          'error while triggering inventory refresh',
          error?.response
        );
        reject(error?.response);
      });
  });
};

export const GetInventoryRefreshStatus = (
  token: string,
  taskId: string
): Promise<ApiResponse> => {
  const url = `${APIPaths.inventory_refresh_status}?task_id=${taskId}`;

  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', url, token, null)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log(
          'error while getting inventory refresh status',
          error?.response
        );
        reject(error?.response);
      });
  });
};

export const GetSingleInventoryForEditById = (
  id: string,
  token: string
): Promise<ApiResponse> => {
  const url = `${APIPaths.inventory}write/${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost('Post', url, null, token, null, OperationType.Read)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log('error while getting single inventory', error?.response);
        reject(error?.response);
      });
  });
};
export interface subItemsData {
  id?: string;
  sku?: string;
  name?: string;
  enabled?: boolean;
  can_save_notification?: boolean;
  locations?: Array<{
    location_id: string;
    name: string;
  }>;
}
interface GetInentoryListResponse {
  data?: {
    data?: {
      is_success: boolean;
      message: string;
      page_count: number;
      total_count: number;
      data?: {
        page_count?: number;
        results: subItemsData[];
      };
    };
  };
}

interface payload {
  page?: number;
  search?: string;
}

export const GetInventorySubItemsList = (
  token: string,
  model?: payload
): Promise<GetInentoryListResponse> => {
  const url = `${APIPaths.inventory}`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost('Post', url, model, token, null, OperationType.Read)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log('error while getting inventory list', error?.response);
        reject(error?.response);
      });
  });
};

export const GetInventoryListV2 = (
  token: string,
  model?: payload
): Promise<GetInentoryListResponse> => {
  const url = `${APIPaths.inventoryv2}`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost('Post', url, model, token, null, OperationType.Read)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log('error while getting inventory list', error?.response);
        reject(error?.response);
      });
  });
};

// export const GetSingleInventoryForEdit = (
//   id: string,
//   token: string
// ): Promise<ApiResponse> => {
//   const url = `${APIPaths.inventory}${id}/`;
//   return new Promise((resolve, reject) => {
//     interceptor
//       .axiosGet('Get', url, token, null)
//       .then((res) => {
//         resolve(res);
//       })
//       .catch((error) => {
//         console.log('error while getting single inventory', error?.response);
//         reject(error?.response);
//       });
//   });
// };

export const DeleteInventory = (
  token: string,
  id: string
): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosDelete('Delete', `${APIPaths.inventory}write/${id}/`, null, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log('Delete Team Error:', error?.response);
        reject(error?.response);
      });
  });
};
export const GetProductsWithPaginationAndSearch = (
  token: string,
  page?: number,
  search?: string
): Promise<GetProductsWithPaginationAndSearchResponse> => {
  const params = new URLSearchParams();

  if (page != null) {
    params.append('page', page.toString());
  }

  if (search) {
    params.append('search', search);
  }

  const url = `${APIPaths.products_v2}?${params.toString()}`;

  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', url, token, null)
      .then((res) => resolve(res as GetProductsWithPaginationAndSearchResponse))
      .catch((error) => {
        console.log('error?.response?.data?.error', error?.response);
        reject(error?.response);
      });
  });
};
export const GetInventoryList = (
  token: string,
  payload?: Record<string, unknown>
): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        `${APIPaths.inventory}`,
        payload ?? null,
        token,
        null,
        OperationType.Read
      )
      .then((res) => resolve(res))
      .catch((error) => {
        console.log('Get Inventory List Error:', error?.response);
        reject(error?.response);
      });
  });
};
